import React from 'react'
import { FormGroup, Col, ControlLabel } from 'react-bootstrap'
import { DropdownList, Multiselect } from 'react-widgets'
import IconTooltip from './IconTooltip'
import 'react-widgets/dist/css/react-widgets.css'

export default class Dropdown extends React.Component {

  onChange(value) {
    if (this.props.deselectable && value.id == null) {
      value = null
    }
    this.props.onChange(value)
  }

  render() {
  
    let { label, value, filter, textField, valueField, defaultValue, multiple, id, valid = true, controlWidth = 10, valueComponent, help } = this.props
    let { labelWidth = 2, placeholder, data, disabled, deselectable, deselectableText = 'None', messages={ emptyList: "Er zijn geen items in deze lijst", emptyFilter: "Uw zoekterm heeft geen resultaten opgeleverd"}, onSearch } = this.props

    if (deselectable) {
      let deselect = {id: null}
      if (typeof textField === 'string') {
        deselect[textField] = deselectableText
      }
      data = [deselect, ...data]
    }

    const componentProps = {
      filter: filter, textField: textField, valueField: valueField, data: data, value: value, valueComponent: valueComponent,
      onChange: this.onChange.bind(this), id: id, placeholder: placeholder, disabled: disabled, messages: messages, onSearch: onSearch, defaultValue: defaultValue
    }

    return (
      <div className={`dropdown-list ${ this.props.dlClassNames }`}>
        { label ? <FormGroup validationState={valid ? null : 'error'}>
          <Col componentClass={ControlLabel} sm={labelWidth}>
            {label} { help && <IconTooltip icon='question-circle' text={help} /> }
          </Col>
          <Col sm={controlWidth}>
            { multiple && <Multiselect {...componentProps}/>}
            { !multiple && <DropdownList {...componentProps} filter/>}
          </Col>
        </FormGroup>
        : <div className="dropdown-inner">
          { multiple && <Multiselect {...componentProps}/>}
          { !multiple && <DropdownList {...componentProps} filter/>}
        </div> }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Dropdown.js